export default "__VITE_ASSET__BZwzLTYL__"